module.exports = __webpack_public_path__ + "img/documentation3-ejaf-tech-canada.6cd45db9.jpg";